<script>
import { defineComponent } from 'vue'
import usePlateKeyboard from '@/components/usePlateKeyboard'

export default defineComponent({
  name: 'ParkingEnter',
  components: {
    Header: () => import('./components/Header.vue'),
    Content: () => import('./components/Content.vue'),
    Footer: () => import('./components/Footer.vue'),
    PlateKeyboard: () => import('@/components/PlateKeyboard.vue')
  },
  setup() {
    return {
      ...usePlateKeyboard()
    }
  }
})
</script>

<template>
  <div class="parking-enter-container" @click="hideKeyboard">
    <Header />
    <div class="main-container">
      <Content />
    </div>

    <Footer />

    <PlateKeyboard />
  </div>
</template>

<style lang="scss" scoped>
.parking-enter-container {
  .main-container {
    position: relative;
    background-color: #fff;
    margin: -51px 12px 0;
    box-sizing: border-box;
    border-radius: 6px;
    overflow: hidden;
  }
}
</style>
